import { z } from 'zod';

// Reuse website field validator from contacts
export const websiteField = z.string().refine(
  (value) => {
    if (!value || value.trim() === '') {
      return true;
    }
    let url = value;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.hostname.includes('.');
    } catch {
      return false;
    }
  },
  { message: 'invalid_url' },
);

// Schema for creating a company
export const createCompanySchema = z.object({
  name: z.string().min(1, 'name_required'),
  teamMemberIds: z.array(z.string()).optional(),
  phoneNumbers: z.array(z.string()).optional(),
  website: websiteField.optional(),
});

export type CreateCompanyFormData = z.infer<typeof createCompanySchema>;

// Utility to validate a single URL
export function validateWebsite(value: string): boolean {
  if (!value.trim()) {
    return true;
  }
  return websiteField.safeParse(value).success;
}
